import { useCallback } from 'react';

import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

export function useRefetchClusters(): VoidFunction {
  const { refetch: refetchClusters } = useGetClustersQuery();
  const isNarrow = useListingLayoutIsNarrowSelector();

  return useCallback(() => {
    if (isNarrow) {
      refetchClusters();
    }
  }, [isNarrow, refetchClusters]);
}
